<template>
  <div class="moderation-summary__comments">
    <div v-for="(comment, idx) in previousComments" :key="idx" class="comment">
      <p class="comment__meta">
        <span class="comment__user">{{ comment.user }}</span>
        <span class="comment__date">{{
          comment.date | moment("YYYY-MM-DD")
        }}</span>
      </p>
      <p class="comment__message" v-html="comment.comment"></p>
      <a
        v-if="!moderationDisabled"
        href="#"
        class="comment__message-reuse"
        @click.prevent="useComment(idx)"
        >(Ponownie użyj tego komentarza)</a
      >
    </div>
  </div>
</template>

<script>
import BaseAdminCertificationSummaryComment from "./BaseAdminCertificationSummaryComment";

export default {
  name: "BaseUserCertificationSummaryComment",
  extends: BaseAdminCertificationSummaryComment
};
</script>
